import Adicionar from './Adicionar';
import Default from './Default';
import Visualizar from './Visualizar';

const AssinaturasDefault = Default;

export default AssinaturasDefault;
export const AssinaturasAdicionar = Adicionar;
export const AssinaturasVisualizar = Visualizar;
